import { Reducer } from 'redux';

import {
  ITxnCollection,
  ISwapStats,
  IItemCollection,
  ICartItemCollection,
  IItemEdge,
} from 'stubs/graphql/swap';
import { SWAP_ACTIONS, ISwapActions } from './actions';

export interface ISearchResults {
  total: number;
  pageNumber: number;
  pageSize: number;
  collection: IItemCollection;
}

export interface ISwapStore {
  txns: ITxnCollection;
  stats: ISwapStats;
  search: ISearchResults;
  cart: ICartItemCollection;
  item: IItemEdge | null;
}

export const initialState: ISwapStore = {
  txns: { edges: [] },
  stats: { inItemCount: 0, outItemCount: 0, pointsEarned: 0, pointsUsed: 0 },
  search: { total: 0, pageSize: 0, pageNumber: 0, collection: { edges: [] } },
  cart: { edges: [] },
  item: null,
};

// --------------
// Reducer
// --------------

export const swapReducer: Reducer<ISwapStore, ISwapActions> = (
  state: ISwapStore = initialState,
  action: ISwapActions
) => {
  switch (action.type) {
    case SWAP_ACTIONS.UPDATE_RETRIEVE_ALL_TXNS: {
      return { ...state, txns: action.txns };
    }
    case SWAP_ACTIONS.UPDATE_RETRIEVE_SWAP_STATS: {
      return { ...state, stats: action.stats };
    }
    case SWAP_ACTIONS.UPDATE_SEARCH_RESULTS: {
      if (action.search.pageNumber === 0) {
        return { ...state, search: action.search };
      }

      const newSearch = {
        total: action.search.total,
        pageSize: action.search.pageSize,
        pageNumber: action.search.pageNumber,
        collection: state.search.collection,
      };

      newSearch.collection.edges = newSearch.collection.edges.concat(
        action.search.collection.edges
      );

      return { ...state, search: newSearch };
    }
    case SWAP_ACTIONS.UPDATE_CART: {
      return { ...state, cart: action.cart };
    }
    case SWAP_ACTIONS.UPDATE_ITEM_DETAILS: {
      return { ...state, item: action.item };
    }
    default: {
      return state;
    }
  }
};
